import { Vec3 } from 'playcanvas';

import { Events } from '../events';
import { Scene } from '../scene';

class AnnotationTool {
    private events: Events;
    private scene: Scene;
    private canvas: HTMLElement;
    private active = false;
    private clicked = false;
    private clickX = 0;
    private clickY = 0;

    constructor(events: Events, scene: Scene, canvas: HTMLElement) {
        this.events = events;
        this.scene = scene;
        this.canvas = canvas;

        const isPrimary = (event: PointerEvent) => (event.pointerType === 'mouse' ? event.button === 0 : event.isPrimary);
        const pointerdown = (event: PointerEvent) => {
            if (events.invoke('annotation.editingCamera')) {
                this.clicked = false;
                return;
            }
            if (isPrimary(event)) {
                this.clicked = true;
                this.clickX = event.offsetX;
                this.clickY = event.offsetY;
            }
        };
        const pointermove = (event: PointerEvent) => {
            if (this.clicked && Math.hypot(event.offsetX - this.clickX, event.offsetY - this.clickY) > 6) {
                this.clicked = false;
            }
        };
        const pointerup = async (event: PointerEvent) => {
            if (!this.clicked || !isPrimary(event)) return;
            this.clicked = false;
            event.preventDefault();
            event.stopPropagation();

            const width = Math.max(1, this.canvas.clientWidth);
            const height = Math.max(1, this.canvas.clientHeight);
            const result = await this.scene.camera.intersect(this.clickX / width, this.clickY / height);
            if (result && !events.invoke('annotation.editingCamera')) {
                this.events.invoke('annotation.commitEdits');
                this.events.fire('annotation.create', result.position as Vec3);
            }
        };

        this.activate = () => {
            this.active = true;
            this.canvas.addEventListener('pointerdown', pointerdown);
            this.canvas.addEventListener('pointermove', pointermove);
            this.canvas.addEventListener('pointerup', pointerup, true);
            this.scene.forceRender = true;
        };
        this.deactivate = () => {
            this.active = false;
            this.clicked = false;
            this.canvas.removeEventListener('pointerdown', pointerdown);
            this.canvas.removeEventListener('pointermove', pointermove);
            this.canvas.removeEventListener('pointerup', pointerup, true);
            this.scene.forceRender = true;
        };
    }

    activate: () => void;
    deactivate: () => void;
}

export { AnnotationTool };
